import { render, staticRenderFns } from "./securedMedia.vue?vue&type=template&id=fc445daa&scoped=true"
import script from "./securedMedia.vue?vue&type=script&lang=js"
export * from "./securedMedia.vue?vue&type=script&lang=js"
import style0 from "./securedMedia.vue?vue&type=style&index=0&id=fc445daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc445daa",
  null
  
)

export default component.exports